import { render, staticRenderFns } from "./AssignAppModule.vue?vue&type=template&id=695a91b6&scoped=true"
import script from "./AssignAppModule.vue?vue&type=script&lang=js"
export * from "./AssignAppModule.vue?vue&type=script&lang=js"
import style0 from "./AssignAppModule.vue?vue&type=style&index=0&id=695a91b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695a91b6",
  null
  
)

export default component.exports